<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="上级ID" prop="parentId">
        <el-input v-model="dataForm.parentId" placeholder="上级ID"></el-input>
      </el-form-item>
      <el-form-item label="简称" prop="shortName">
        <el-input v-model="dataForm.shortName" placeholder="简称"></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="longitude">
        <el-input v-model="dataForm.longitude" placeholder="经度"></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="latitude">
        <el-input v-model="dataForm.latitude" placeholder="纬度"></el-input>
      </el-form-item>
      <el-form-item label="层级" prop="level">
        <el-input v-model="dataForm.level" placeholder="层级"></el-input>
      </el-form-item>
      <el-form-item label="位置" prop="position">
        <el-input v-model="dataForm.position" placeholder="位置"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        name: '',
        parentId: '',
        shortName: '',
        longitude: '',
        latitude: '',
        level: '',
        position: '',
        sort: ''
      },
      dataRule: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'}
        ],
        parentId: [
          {required: true, message: '上级ID不能为空', trigger: 'blur'}
        ],
        longitude: [
          {required: true, message: '经度不能为空', trigger: 'blur'}
        ],
        latitude: [
          {required: true, message: '纬度不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/area/list`),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              'id': id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/area/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'name': this.dataForm.name,
              'parentId': this.dataForm.parentId,
              'shortName': this.dataForm.shortName,
              'longitude': this.dataForm.longitude,
              'latitude': this.dataForm.latitude,
              'level': this.dataForm.level,
              'position': this.dataForm.position,
              'sort': this.dataForm.sort
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.$emit('refreshDataList')
              this.visible = false
            this.$message({
              message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/area-add-or-update.vue